module.exports = __webpack_public_path__ + "img/empty_5.d25a2532.png";